var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative","cursor":"pointer"},on:{"click":_vm.toggleVisibility}},[_c('TooltipIcon'),(_vm.isVisible)?_c('span',{staticClass:"tooltip",domProps:{"innerHTML":_vm._s(_vm.tooltipText)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }